import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Button,
  Form,
  Header,
  Message,
  Modal,
  RadioItem,
  InputFieldReduxFormWrapper as InputField,
} from '@adc/ui-core'
// import InputField from '../../formFields/inputField'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const NAME_MAX_LENGTH = 64
const SAVE_CHOICE_CREATE = 'CREATE'
const SAVE_CHOICE_UPDATE = 'UPDATE'
const TYPE_CHOICE_PERSONAL = 'PERSONAL'
const TYPE_CHOICE_GLOBAL = 'GLOBAL'

class SaveSearchModal extends Component {
  static propTypes = {
    bOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    isCreateMode: PropTypes.bool.isRequired,
    isUserGlobalSearchManager: PropTypes.bool.isRequired,
    currentSavedSearchType: PropTypes.string,
    defaultName: PropTypes.string,
    searches: PropTypes.array.isRequired,
  }

  static defaultProps = {
    defaultName: '',
  }

  state = {
    name: '',
    touched: false,
    saveChoice: SAVE_CHOICE_UPDATE,
    typeChoice: TYPE_CHOICE_PERSONAL,
  }

  onInputChange = event => {
    this.setState({
      name: event.target.value,
      touched: true,
    })
  }

  onSaveChoiceChange = (e, { value }) => {
    this.setState({ saveChoice: value })
  }

  onTypeChoiceChange = (e, { value }) => {
    this.setState({ typeChoice: value })
  }

  onSave = () => {
    const { isCreateMode, onCreate, onUpdate } = this.props
    const { name, saveChoice, typeChoice } = this.state

    if (!isCreateMode && saveChoice === SAVE_CHOICE_UPDATE) {
      onUpdate()
    } else {
      onCreate(name, typeChoice)
    }
  }

  getErrors = () => {
    const { name, saveChoice } = this.state
    const { isCreateMode } = this.props
    if (!isCreateMode && saveChoice === SAVE_CHOICE_UPDATE) return ''
    if (name === '') return 'Required'
    if (
      _.find(
        this.props.searches,
        search => _.toLower(search.saved_search_name) === _.toLower(name)
      )
    ) {
      return 'Duplicate name. Please re-specify.'
    }
  }

  /**
   * We forceCreateOnly mode when:
   * a) it's a non-GSM user and it's not a personal search they are saving
   * b) it's not create mode (in which case we aren't "forcing")
   */
  forceCreateOnly = () => {
    const { isUserGlobalSearchManager, currentSavedSearchType, isCreateMode } =
      this.props
    return (
      !isUserGlobalSearchManager &&
      currentSavedSearchType !== 'PERSONAL' &&
      !isCreateMode
    )
  }

  componentDidUpdate(prevProps) {
    if (this.props.bOpen && !prevProps.bOpen) {
      // eslint-disable-next-line
      this.setState({
        name: this.props.defaultName,
        touched: false,
        saveChoice: this.forceCreateOnly()
          ? SAVE_CHOICE_CREATE
          : SAVE_CHOICE_UPDATE,
      })
    }
    if (
      this.props.isUserGlobalSearchManager !==
        prevProps.isUserGlobalSearchManager ||
      this.props.currentSavedSearchType !== prevProps.currentSavedSearchType
    ) {
      // eslint-disable-next-line
      this.setState({
        saveChoice: this.forceCreateOnly()
          ? SAVE_CHOICE_CREATE
          : SAVE_CHOICE_UPDATE,
      })
    }
  }

  /**
   * Had to handle this like this (vs a submit button) because when radio only is showing, enter-to-submit doesn't work
   */
  checkSubmit = e => {
    if (e && e.keyCode === 13 && !this.getErrors()) this.onSave()
  }

  renderTypeOptions = () => {
    const { typeChoice } = this.state
    return (
      this.props.isUserGlobalSearchManager && (
        <div className={cx('type-options')}>
          <span>Type:</span>
          <RadioItem
            label='Personal'
            name='typeChoice'
            value={TYPE_CHOICE_PERSONAL}
            checked={typeChoice === TYPE_CHOICE_PERSONAL}
            onChange={this.onTypeChoiceChange}
            data-elm-id='save_type_personal'
            className={cx('inline-radio')}
          />
          <RadioItem
            label='Global'
            name='typeChoice'
            value={TYPE_CHOICE_GLOBAL}
            checked={typeChoice === TYPE_CHOICE_GLOBAL}
            onChange={this.onTypeChoiceChange}
            data-elm-id='save_type_global'
            className={cx('inline-radio')}
          />
        </div>
      )
    )
  }

  render() {
    const {
      bOpen,
      onClose,
      isCreateMode,
      currentSavedSearchType,
      isUserGlobalSearchManager,
    } = this.props
    const { touched, saveChoice, typeChoice } = this.state
    const inputFieldStyle = isCreateMode
      ? {}
      : {
          marginLeft: this.forceCreateOnly() ? 0 : 26,
          visibility: saveChoice === SAVE_CHOICE_UPDATE ? 'hidden' : 'visible',
        }

    return (
      bOpen && (
        <Modal
          closeOnDimmerClick={false}
          elmId='save_new_search_modal'
          size='tiny'
          open={bOpen}
          onClose={onClose}
          closeIcon={false}
        >
          <Header
            data-elm-id='save_new_search_modal_header'
            icon='save'
            content={`Save ${isCreateMode ? 'New ' : ''}Search`}
          />
          <Modal.Content>
            <Form>
              <div onKeyUp={this.checkSubmit}>
                {this.forceCreateOnly() && (
                  <p>
                    This is a <strong>global</strong> search. You do not have
                    the rights to update it; however you may save a copy of it
                    as a <strong>personal</strong> search:
                  </p>
                )}
                {!isCreateMode && !this.forceCreateOnly() && (
                  <div>
                    <p className={cx('line-pad')}>Would you like to</p>
                    <div className={cx('line-pad')}>
                      <RadioItem
                        label={
                          <span>
                            Update existing{' '}
                            <strong>
                              {currentSavedSearchType.toLowerCase()}
                            </strong>{' '}
                            search: "{this.props.defaultName}"
                          </span>
                        }
                        name='saveChoice'
                        value={SAVE_CHOICE_UPDATE}
                        checked={saveChoice === SAVE_CHOICE_UPDATE}
                        onChange={this.onSaveChoiceChange}
                        data-elm-id='save_search_update_choice'
                        autoFocus
                      />
                    </div>
                    <div className={cx('line-pad')}>
                      <RadioItem
                        label={
                          <span>
                            Save as new{' '}
                            {!isUserGlobalSearchManager && (
                              <strong>personal </strong>
                            )}
                            search
                          </span>
                        }
                        name='saveChoice'
                        value={SAVE_CHOICE_CREATE}
                        checked={saveChoice === SAVE_CHOICE_CREATE}
                        onChange={this.onSaveChoiceChange}
                        data-elm-id='save_search_create_choice'
                      />
                    </div>
                  </div>
                )}
                <div style={inputFieldStyle}>
                  <InputField
                    compact
                    required
                    name='name'
                    placeholder='Specify a name'
                    label='Name'
                    elmId='save_search_name'
                    helpContent='Specify a unique name for your search.'
                    showTooltip
                    input={{
                      onChange: this.onInputChange,
                      onBlur: _.noop,
                      value: this.state.name,
                      maxLength: NAME_MAX_LENGTH,
                      autoFocus: true,
                    }}
                    meta={{ touched, error: this.getErrors() }}
                  />
                  {this.renderTypeOptions()}
                </div>
              </div>
            </Form>
            {isCreateMode && typeChoice === TYPE_CHOICE_PERSONAL && (
              <Message info>
                <Message.Header>
                  What's included in a saved search?
                </Message.Header>
                <p>
                  When you save a search, the following will be stored: filters,
                  grid layout and sort order. Only you will have access to this
                  search.
                </p>
              </Message>
            )}
            {isCreateMode && typeChoice === TYPE_CHOICE_GLOBAL && (
              <Message info>
                <Message.Header>What's a "global" saved search?</Message.Header>
                <p>
                  Global saved searches are available to all users. Only
                  business-critical searches that are useful to multiple people
                  should be saved as global.
                </p>
              </Message>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              size='small'
              id='cancel'
              elmId='save_new_search_cancel_button'
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              size='small'
              disabled={!!this.getErrors()}
              role='primary'
              id='save'
              elmId='save_new_search_save_button'
              onClick={this.onSave}
            >
              Save
            </Button>
          </Modal.Actions>
        </Modal>
      )
    )
  }
}

export default SaveSearchModal
